import { Check, ChevronRight } from 'lucide-react';

// Empty-state checklist: steps = [{ label, hint, done, action: { label, onClick } }]
export function GettingStarted({ title, subtitle, steps, testId = 'getting-started' }) {
  const next = steps.findIndex(s => !s.done);
  return (
    <div data-testid={testId} className="ff-card p-6 md:p-8 max-w-3xl mx-auto">
      <p className="text-[10px] tracking-[0.25em] uppercase font-semibold text-[#FF4500] mb-2">Getting started</p>
      <h3 className="text-xl md:text-2xl font-bold text-white mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>{title}</h3>
      {subtitle && <p className="text-sm text-[#8A8A93] mb-6">{subtitle}</p>}
      <ol className="space-y-3">
        {steps.map((s, i) => {
          const current = i === next;
          return (
            <li key={i} data-testid={`${testId}-step-${i}`} className={`flex items-start gap-4 p-4 rounded-xl border transition-all ${current ? 'border-[#FF4500]/40 bg-[#FF4500]/[0.06]' : s.done ? 'border-[#10B981]/20 bg-[#10B981]/[0.04]' : 'border-white/[0.06] bg-white/[0.02] opacity-70'}`}>
              <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${s.done ? 'bg-[#10B981] text-white' : current ? 'bg-[#FF4500] text-white' : 'bg-white/[0.06] text-[#8A8A93]'}`}>
                {s.done ? <Check className="w-4 h-4" /> : i + 1}
              </span>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-semibold ${s.done ? 'text-[#10B981] line-through decoration-[#10B981]/40' : 'text-white'}`}>{s.label}</p>
                {s.hint && <p className="text-xs text-[#8A8A93] mt-0.5">{s.hint}</p>}
              </div>
              {s.action && !s.done && (
                <button data-testid={`${testId}-action-${i}`} onClick={s.action.onClick} disabled={!current && s.action.requiresPrevious}
                  className={`shrink-0 flex items-center gap-1 text-xs px-3 py-2 rounded-lg font-medium transition-all disabled:opacity-40 ${current ? 'bg-[#FF4500] text-white hover:bg-[#E03C00]' : 'bg-white/[0.05] text-[#c8c8d0] hover:text-white'}`}>
                  {s.action.label} <ChevronRight className="w-3.5 h-3.5" />
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
